import { render, staticRenderFns } from "./fullscreen-loader.vue?vue&type=template&id=dcf74456&scoped=true"
import script from "./fullscreen-loader.vue?vue&type=script&lang=js"
export * from "./fullscreen-loader.vue?vue&type=script&lang=js"
import style0 from "./fullscreen-loader.vue?vue&type=style&index=0&id=dcf74456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf74456",
  null
  
)

export default component.exports